import { Tab, TabBar, TabBarContainer, TabPanel } from './components';

export const Tabs = {
  Bar: TabBar,
  BarContainer: TabBarContainer,
  Panel: TabPanel,
  Tab,
} as const;
